import type {
	RouterConfig
} from "@nuxt/schema";
import type {
	RouteRecordRaw
} from "#vue-router";

export default {
	routes: ( _routes: readonly RouteRecordRaw[] ) => [
		{
			name: "default",
			path: "/",
			redirect: "/home"
		},
		{
			name: "home",
			path: "/home",
			component: () => import( "~/pages/Home.vue" )
		},
		{
			name: "dress-code",
			path: "/dress-code",
			component: () => import( "~/pages/DressCode.vue" )
		},
		{
			name: "gallery",
			path: "/gallery",
			component: () => import( "~/pages/Gallery.vue" )
		},
		{
			name: "wedding-party",
			path: "/wedding-party",
			component: () => import( "~/pages/WeddingParty.vue" )
		},
		{
			name: "q-and-a",
			path: "/q-and-a",
			component: () => import( "~/pages/QandA.vue" )
		},
		{
			name: "travel",
			path: "/travel",
			component: () => import( "~/pages/Travel.vue" )
		},
		{
			name: "registry",
			path: "/registry",
			component: () => import( "~/pages/Registry.vue" )
		},
		{
			name: "password",
			path: "/password",
			component: () => import( "~/pages/Password.vue" )
		},
		{
			name: "rsvp",
			path: "/rsvp",
			component: () => import( "~/pages/RSVP.vue" )
		},
		{
			name: "guest-rsvp",
			path: "/rsvp/:id",
			component: () => import( "~/pages/rsvp/[id].vue" )
		}
	]
} satisfies RouterConfig;